var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.477%",
    y1: "91.865%",
    x2: "23.301%",
    y2: "9.764%",
    id: "0zzs0hscna"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36CFC8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAF9F6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-46.6%",
    y: "-33.3%",
    width: "193.2%",
    height: "166.7%",
    filterUnits: "objectBoundingBox",
    id: "36jfi8ov1b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.188176939 0 0 0 0 0.720742985 0 0 0 0 0.695889903 0 0 0 0.827304121 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#0zzs0hscna)",
    cx: 21.5,
    cy: 21.5,
    r: 21.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#36jfi8ov1b)",
    transform: "translate(13 10)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.595 12.87a.596.596 0 0 0-.593.643l.778 9.638A.923.923 0 0 0 1.7 24h13.768a.923.923 0 0 0 .92-.85l.777-9.637a.596.596 0 0 0-.594-.644H.595z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55 15.296a.168.168 0 0 1 .163.219l-1.94 5.664a.168.168 0 0 1-.318-.108l1.94-5.665a.168.168 0 0 1 .154-.11zM6.15 16.644h.001a.168.168 0 0 1 .126.287l-1.394 1.395 1.394 1.394a.168.168 0 0 1-.237.238l-1.426-1.424a.294.294 0 0 1 0-.416l1.426-1.424c.03-.03.07-.048.111-.05zM10.904 16.649a.169.169 0 0 1 .123.046l1.424 1.424a.294.294 0 0 1 0 .416l-1.424 1.424a.168.168 0 0 1-.238-.238l1.394-1.394-1.394-1.395a.168.168 0 0 1 .115-.283z",
    fill: "#131010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.295 9.82 4.007 2.583c.063.04.125.084.184.13H1.68c.06-.046.121-.09.184-.13L5.872 9.82a3.517 3.517 0 0 0 5.423 0z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.595 4.754c.094 0 .17.077.17.171V7.58a3.18 3.18 0 0 1-6.362 0V5.586a.17.17 0 0 1 .197-.17 4.627 4.627 0 0 0 4.235-1.608.026.026 0 0 1 .041.002 2.07 2.07 0 0 0 1.72.943h-.001z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.578 3.593a4.292 4.292 0 0 1-3.929 1.492.507.507 0 0 0-.582.501v1.668a3.218 3.218 0 0 1-1.15-2.466V3.224A3.223 3.223 0 0 1 7.141 0h1.971a3.17 3.17 0 0 1 2.64 1.415c.1.15.256.251.432.282a1.287 1.287 0 0 1 1.065 1.267v1.824c0 .951-.42 1.854-1.149 2.465V4.925a.507.507 0 0 0-.503-.507 1.733 1.733 0 0 1-1.438-.79.362.362 0 0 0-.581-.036z",
    fill: "#FFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.9075b3b962aac10bed6091091d3d9ddd.svg";
export { ForwardRef as ReactComponent };